import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { PickerOverlay } from 'filestack-react';

import * as S from './style';
import UploadedFilesList from './uploaded-files-list';
import { postMessage } from '../../utils';

const renderPicker = (t, onChange, onClose, maxFiles = 1, format = ['image/jpeg']) => {
  return (
    <PickerOverlay
      apikey="AFfRSmXhjTZCmP1NoBiKSz"
      pickerOptions={{
        accept: format,
        fromSources: ['local_file_system'],
        disableTransformer: true,
        lang: 'en',
        maxFiles: maxFiles,
        maxSize: 10000000,
        onClose: (res) => {
          onClose(res);
        },
        customText: {
          'Select Files to Upload': t('Select Files to Upload'),
          'or Drag and Drop, Copy and Paste Files': t('or Drag and Drop, Copy and Paste Files'),
          'Selected Files': t('Selected Files'),
          Filter: t('Filter'),
          Images: t('Images'),
          'Deselect All': t('Deselect All'),
          'Upload more': t('Upload More'),
          Upload: t('Upload'),
          'Change files': t('Change files'),
        },
      }}
      onError={(res) => {
        onClose(res);
      }}
      onSuccess={(res) => {
        onChange(res);
      }}
      key="picker"
    />
  );
};

const FilepickerInput = ({ form, field, options }) => {
  const { t } = useTranslation();
  const [isPickerShown, setIsPickerShown] = useState(false);
  const [value, setValue] = useState([]);

  const onChangeHandler = async ({ filesUploaded: files }) => {
    setValue(files);
    form.setFieldValue(
      field.name,
      files.map((file) => file.url),
    );
    form.setFieldValue(
      `${field.name} Handle`,
      files.map((file) => file.handle),
    );
  };

  const onCloseHandler = () => {
    setIsPickerShown(false);
    form.setFieldTouched(field.name, true, true);
  };

  return (
    <>
      <S.Caption>{t('File_Uploader_T2')}</S.Caption>
      <S.Button
        onClick={(e) => {
          e.preventDefault();
          setIsPickerShown(true);
          postMessage('track', { action: 'CTA_FILES' });
        }}
      >
        {value && value.length ? t('Change files') : t('File_Uploader_T3')}
      </S.Button>

      <UploadedFilesList files={value} />

      {isPickerShown
        ? renderPicker(t, onChangeHandler, onCloseHandler, options?.maxFiles, options?.format)
        : null}
    </>
  );
};

export default FilepickerInput;

FilepickerInput.propTypes = {
  form: PropTypes.object,
  field: PropTypes.object,
  options: PropTypes.object,
};
